import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import * as yup from 'yup';

import { useOrderMutations } from '@/hooks/useOrderMutations';
import AddRecommendationCodeComponent from '@/components/AddRecommendationCode/AddRecommendationCodeComponent';
import { showToast } from '@/store/ducks/toasts';

const AddRecommendationCodeContainer = ({ orderId, closeModal, refreshHandler }) => {
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { addRecommendation } = useOrderMutations(orderId);

  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        code: yup.string().required(intl.formatMessage({ id: 'REQUIRED_FIELD' })),
      }),
    [intl]
  );

  const handleSubmit = async (values, { setSubmitting }) => {
    addRecommendation.mutate(
      { code: values.code },
      {
        onSuccess: () => {
          refreshHandler();
          dispatch(
            showToast({
              type: 'success',
              title: intl.formatMessage({ id: 'SUCCESS' }),
              text: intl.formatMessage({
                id: 'ADD_REFERRAL_CODE_TO_ORDER_SUCCESS',
              }),
              duration: 5000,
            })
          );
          closeModal();
        },
        onError: (err) => {
          console.log(err?.response || err);
          setError(
            err?.response?.status === 500 || !err?.response?.data?.message
              ? intl.formatMessage({ id: 'UNKNOWN_ERROR' })
              : intl.formatMessage({ id: err.response.data.message })
          );
        },
        onSettled: () => {
          setSubmitting(false);
        },
      }
    );
  };


  return (
    <AddRecommendationCodeComponent
      error={error}
      validationSchema={validationSchema}
      handleSubmit={handleSubmit}
      intl={intl}
    />
  );
};

AddRecommendationCodeContainer.propTypes = {
  orderId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  refreshHandler: PropTypes.func.isRequired,
};

export default AddRecommendationCodeContainer;
